;(function ($, YI) {

    $(function() {

        if (typeof component_name === 'string' && typeof YI[component_name] === 'function') {
            YI[component_name]();
        }
    });
	
})(jQuery, window.yesidea || (window.yesidea = {}));

var min = 5, // 5 минут
cache = {
    limit: min * 60 * 1000,
    get: function (name) {
        var result = null,
            item = sessionStorage.getItem(name);
        if (item !== null) {
            item = JSON.parse(item);
            if (+new Date() - item.time < this.limit) {
                result = item.data;
            }
        }
        return result;
    },
    save: function (name, data) {
        if (!this.check()) sessionStorage.clear();
        var value = {
            time: +new Date(),
            data: data
        };
        sessionStorage.removeItem(name);
        sessionStorage.setItem(name, JSON.stringify(value));
    },

    // проверка на переполненость ls
    check: function lsTest(){
        var test = 'yesclienttest';
        try {
            sessionStorage.setItem(test, test);
            sessionStorage.removeItem(test);
            return true;
        } catch(e) {
            return false;
        }
    }
};

function yc(method, options, callback, cacheKey) {
    cacheKey = cacheKey || true;
    if (!method) return false;
    var url = 'https://app-service.aisrb.ru/api/',
        data = {};
    if (options && typeof options === 'object' && options.data) data = options.data;
    if (cacheKey) {
        cacheKey = typeof cacheKey === 'string'
            ? cacheKey
            : encodeURIComponent(JSON.stringify([method,data]))
            .replace(/%/g,'').toUpperCase();
    }
    var result = cacheKey ? cache.get(cacheKey) : null;
    var default_options = {
        headers: {
            'Accept': 'application/json'
        },
        dataType: 'json',
        url: url + method,
        async: typeof callback !== 'undefined',
        success: function (json) {
            result = json.data;
            if(callback) callback(result);
            if (cacheKey) cache.save(cacheKey, result);
        },
        error: function (result) {
            console.error(result);
        }
    };
    if (!result) $.ajax(Object.assign(default_options, options));
    return result;
}

function locationParams(specific, value) {
    var result = {},
        loc = location.search.length ? location.search.slice(1).split('&') : null;
    if (loc) {
        loc.forEach(function (item) {
            item = item.split('=');
            if (item.length > 1 && item[0] && item[1]) result[item[0]] = item[1];
        });
        result = !value && specific && specific in result ? result[specific] : result;
    }
    if (typeof result === 'object' && !Object.keys(result).length || typeof result === 'string' && !result.length) {
        result = {};
    }
    if (typeof value !== 'undefined') {
        var string = '?';
        result[specific] = value;
        Object.keys(result).forEach(function (key) {
            string += key+'='+result[key]+'&';
        });
        result = string.slice(0, -1);
    }
    return result;
}